import PlayerApi from '../../api/Player';

export default {
    state: {
        playerdata: {
            money: {
                balance: 0,
                currency: 'EUR',
            },
        },
        freePlay: false,
    },

    getters: {
        playerdata(state)
        {
            return state.playerdata;
        },
        freePlay(state)
        {
            return state.freePlay;
        },
    },

    mutations: {
        setPlayerData(state, playerdata)
        {
            state.playerdata = Object.assign(playerdata, {}, {});

            // eslint-disable-next-line no-extend-native
            Number.prototype.currency = playerdata.money.currency;
        },
        setMoney(state, money)
        {
            state.playerdata.money.balance = money;
        },
        setCurrency(state, currency)
        {
            if (!this.state.globals.currencyInitialized)
            {
                state.playerdata.money.currency = currency;
                // eslint-disable-next-line no-extend-native
                Number.prototype.currency = state.playerdata.money.currency;
            }
        },
        setFreePlay(state, value)
        {
            state.freePlay = value;
        },
    },

    actions: {
        setPlayerData(context, playerdata)
        {
            context.commit('setPlayerData', playerdata);

            if (playerdata.money.currency)
            {
                context.commit('setCurrencyInitialized');
            }
        },
        async loginplayer(context, data)
        {
            const response = await PlayerApi.login(data);

            if (!response.error)
            {
                context.dispatch('reloadGlobals');
            }

            return response;
        },
        async logoutplayer(context, data)
        {
            const response = await PlayerApi.logout(data);

            if (!response.error)
            {
                context.dispatch('reloadGlobals');
            }

            return response;
        },
        async getBalance({ commit, state })
        {
            let response;

            if (state.freePlay === false)
            {
                response = await PlayerApi.getBalance();
            }

            if (response && !response.error)
            {
                commit('setMoney', response.data.balance);
            }

            return response;
        },
    },
};
